<template>
  <BaseDialog ref="popup">
    <div class="space-between">
      <h2 style="margin-top: 0">{{ title }}</h2>
      <div class="space-between">
        <ToggleButton
          style="margin: 0 20px 12px 0px;"
          :defaultState="showUnassigned"
          v-on:change="triggerEvent"
          id="show_unassigned"
          labelEnableText="Unassigned"
          labelDisableText="All Images"
        />
        <div class="editor-line form-row">
          <input
            @input="onFilterImages()"
            type="text"
            placeholder="Search..."
            v-model="searchModel"
            class="search-input"
          />
        </div>
      </div>
    </div>
    <div class="content-ct">
      <div
        class="image-ct"
        @dblclick="selectImage(img, true)"
        @click="selectImage(img)"
        v-for="(img, i) in images"
        v-bind:key="i"
        v-bind:class="{ 'selected-img': img.file_name === selectedImage }"
      >
        <img class="img-class" :src="`api/fs/${category}/${img.file_name}`" />
        <span class="file-name">{{ img.file_name }}</span>
      </div>
    </div>
    <div class="btns">
      <button class="action-btn cancel" @click="_cancel">
        {{ cancelButton }}
      </button>
      <button class="action-btn confirm" @click="_clear">Clear image</button>
      <button
        class="action-btn confirm"
        :disabled="!selectedImage || selectedImage.length < 2"
        @click="_confirm"
      >
        {{ okButton }}
      </button>
    </div>
  </BaseDialog>
</template>

<script>
import BaseDialog from '../BaseDialog.vue'
import ToggleButton from '@/components/ToggleButton.vue'

export default {
  name: 'ImagePickerDialog',

  components: { BaseDialog, ToggleButton },

  data: () => ({
    // Parameters that change depending on the type of dialogue
    title: undefined,
    images: [],
    all_images: [],
    unassigned_images: [],
    selectedImage: null,
    okButton: 'Submit', // Text for confirm button; leave it empty because we don't know what we're using it for
    cancelButton: 'Cancel', // text for cancel button
    category: '',
    searchModel: '',
    showUnassigned: true,
    // Private variables
    resolvePromise: undefined,
    rejectPromise: undefined,
  }),

  methods: {
    show(opts = {}) {
      this.title = opts.title
      this.all_images = opts.images
      this.unassigned_images = []
      if (opts.assigned_images) {
        this.unassigned_images = this.all_images.filter(
          (el) => opts.assigned_images.indexOf(el.file_name) < 0
        )
      }
      if (this.unassigned_images.length < 1) {
        this.showUnassigned = false
      }
      this.category = opts.category
      this.selectedImage = opts.selectedImage
      if (opts.cancelButton) {
        this.cancelButton = opts.cancelButton
      }
      this.onFilterImages()
      // Once we set our config, we tell the popup modal to open
      this.$refs.popup.open()
      // Return promise so the caller can get results
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },

    onFilterImages() {
      let filteredImages = []
      filteredImages = []
      filteredImages = this.showUnassigned ? this.unassigned_images : this.all_images
      if (this.searchModel && this.searchModel.length > 0) {
        filteredImages = filteredImages.filter(
          (el) => el.file_name.toLowerCase().indexOf(this.searchModel.toLowerCase()) >= 0
        )
      }
      this.images = filteredImages
    },

    triggerEvent(value) {
      this.showUnassigned = value
      this.onFilterImages()
    },

    selectImage(img, withSubmit = false) {
      this.selectedImage = img.file_name
      if (withSubmit) {
        this._confirm()
      }
    },
    _clear() {
      this.$refs.popup.close()
      this.resolvePromise('clear')
    },
    _confirm() {
      this.$refs.popup.close()
      this.resolvePromise(this.selectedImage)
    },

    _cancel() {
      this.$refs.popup.close()
      this.resolvePromise(false)
      // Or you can throw an error
      // this.rejectPromise(new Error('User cancelled the dialogue'))
    },
  },
}
</script>

<style scoped>
.search-input {
  margin-bottom: 12px;
  width: 350px;
  margin-right: 12px;
}
.space-between {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.btns {
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.action-btn {
  padding: 0.5em 1em;
  border-radius: 5px;
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
  cursor: pointer;
}
.confirm {
  background-color: #282f54;
  color: #fff !important;
}

.cancel {
  background-color: #fd6464;
  color: #fff !important;
}
.image-ct {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 200px;
  margin-bottom: 20px;
  cursor: pointer;
}
.selected-img {
  border: 2px solid blue;
}
.img-class {
  border: 1px solid #eee;
}
.content-ct {
  width: 1000px;
  height: 500px;
  overflow: auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  background: #f9f9f9;
  padding: 10px;
  justify-content: space-between;
}
.file-name {
  width: 200px;
  word-wrap: break-word;
  display: block;
  font-size: 10px;
  text-align: center;
  font-weight: 500;
  margin-top: 5px;
}
</style>
